import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'paintfilterlayer',
})
export class PaintFilterLayerPipe implements PipeTransform {
  transform(items: any[], paintfilterlayer: (item: any) => boolean): any {
    if (!items || !paintfilterlayer) {
      return items;
    }
    return items.filter(item => paintfilterlayer(item));
  }
}
